module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.failure) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _c('div', [(_vm.fileLoading) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Loading")]), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "center-align startjobor"
  }, [_c('h4', {
    staticClass: "bold title"
  }, [_vm._v("\n                        " + _vm._s(_vm.nestedMode ? 'Create nested job' : 'Create job for') + "\n                    ")]), _vm._v(" "), (!_vm.nestedMode) ? _c('h4', {
    staticClass: "bold file-name"
  }, [_vm._v(_vm._s(_vm.file.name) + ":")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 init-settings"
  }, [_c('div', {
    staticClass: "col s12 l6 center-align settings-block"
  }, [_c('h5', {
    staticClass: "bold block-title"
  }, [_vm._v("Choose materials:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "visible": _vm.materialvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.materialvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.materialvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.materials[_vm.material - 1].name)), (_vm.materials[_vm.material - 1].trademark) ? _c('span', [_vm._v("™")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.materials), function(material, index) {
    return _c('li', {
      key: material.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.materialChoice(index)
        }
      }
    }, [(index > _vm.predefinedMaterials - 1 && index !== _vm.materials.length - 1) ? _c('i', {
      staticClass: "material-icons a3d color",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeMaterial(index)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")]) : _vm._e(), _vm._v("\n                                            " + _vm._s(material.name)), (material.trademark) ? _c('span', [_vm._v("™")]) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), (!_vm.isValidMaterial) ? _c('div', {
    staticClass: "alert"
  }, [_vm._v("Material is unvalidated")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 l6 center-align settings-block"
  }, [_c('h5', {
    staticClass: "bold block-title"
  }, [_vm._v("Choose printer:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "visible": _vm.printervisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.printervisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.printervisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.printers[_vm.printer - 1].name) + " "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.printers), function(printer, index) {
    return _c('li', {
      key: printer.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.printerChoice(index)
        }
      }
    }, [(index > _vm.predefinedPrinters - 1 && index !== _vm.printers.length - 1) ? _c('i', {
      staticClass: "material-icons a3d color",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removePrinter(index)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")]) : _vm._e(), _vm._v("\n                                            " + _vm._s(printer.name) + "\n                                        ")])])
  }), 0)])])]), _vm._v(" "), (!_vm.printers[_vm.printer - 1].valid) ? _c('div', {
    staticClass: "alert"
  }, [_vm._v("Physical validation is still pending")]) : _vm._e(), _vm._v(" "), (_vm.printer > _vm.predefinedPrinters) ? _c('div', {
    staticClass: "alert"
  }, [_vm._v("Printer is unvalidated")]) : _vm._e()], 1)])]), _vm._v(" "), (!_vm.nestedMode) ? [_c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the units you selected when creating your .stl file (usually mm or cm):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('dropdown', {
    attrs: {
      "visible": _vm.unitvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.unitvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.unitvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.units[_vm.files[0].unit - 1].name) + "\n                                    "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.units), function(unit, index) {
    return _c('li', {
      key: unit.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.unitChoice(index)
        }
      }
    }, [_vm._v(_vm._s(unit.name))])])
  }), 0)])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input thickness of each powder layer (must be consistent with the layer thickness set in your printer):")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thickness.current),
      expression: "thickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thicknessfield"
    },
    domProps: {
      "value": (_vm.thickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.thickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.thickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.thickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the scaling factor you want to apply when printing the file, relative to your .stl file (example: if you want to print at 150% the dimensions of your .stl file, you would enter 1.50):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].scale.current),
      expression: "files[0].scale.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalefield"
    },
    domProps: {
      "value": (_vm.files[0].scale.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].scale)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].scale, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[0].scale.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scale.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the distance between the part and the build platform. (Z-offset)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].hsub.current),
      expression: "files[0].hsub.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hsubfield",
      "disabled": _vm.isWithoutSupport
    },
    domProps: {
      "value": (_vm.files[0].hsub.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[0].hsub)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].hsub, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].hsub.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the temperature of the build platform.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tplate.current),
      expression: "tplate.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tplatefield"
    },
    domProps: {
      "value": (_vm.tplate.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.tplate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tplate, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.tplate.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the build plate thickness.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          A difference of +/- 20% or more is material to the simulation.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.H_buildPlate.current),
      expression: "H_buildPlate.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hbuildplatefield"
    },
    domProps: {
      "value": (_vm.H_buildPlate.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.H_buildPlate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.H_buildPlate, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.H_buildPlate.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your suggested element size:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.element.current),
      expression: "element.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "elementfield"
    },
    domProps: {
      "value": (_vm.element.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.element)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.element, "current", $event.target.value)
      }, function($event) {
        return _vm.calculateElementSizeReset()
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.element.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), (!_vm.checkElementSizeResult || (_vm.checkElementSizeResult && _vm.checkElementSizeError)) ? _c('button', {
    staticClass: "a3d btn multiline",
    attrs: {
      "disabled": _vm.checkElementSizeProcess
    },
    on: {
      "click": function($event) {
        return _vm.calculateElementSize()
      }
    }
  }, [_vm._v("\n                            Confirm that your element size is not too small\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.checkElementSizeProcess) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (_vm.checkElementSizeResult) ? _c('div', {
    staticClass: "block-note bold",
    class: {
      'error': _vm.checkElementSizeError
    }
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                " + _vm._s(_vm.checkElementSizeResult) + "\n                            ")])]) : _vm._e()])]), _vm._v(" "), (!this.showAdvanced) ? _c('div', {
    staticClass: "divider-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.confirmAdvanced()
      }
    }
  }, [_vm._v("\n                        Advanced Options\n                    ")])]) : _c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Advanced Options\n                ")])]), _vm._v(" "), (this.showAdvanced) ? _c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Infill laser scan speed:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.speed.current),
      expression: "speed.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "speedfield"
    },
    domProps: {
      "value": (_vm.speed.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.speed)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.speed, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.speed.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Infill laser beam diameter:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diameter.current),
      expression: "diameter.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "diameterfield"
    },
    domProps: {
      "value": (_vm.diameter.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.diameter)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.diameter, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.diameter.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid diameter.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Infill laser power:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.power.current),
      expression: "power.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "powerfield"
    },
    domProps: {
      "value": (_vm.power.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.power)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.power, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W")])]), _vm._v(" "), (_vm.power.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid power.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                          Number of lasers employed for this build\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          (only impacts build time calculation)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nlaser.current),
      expression: "nlaser.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "nlaserfield"
    },
    domProps: {
      "value": (_vm.nlaser.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.nlaser)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nlaser, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.nlaser.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid number of lasers.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Laser scanning speed for support structures:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vlaserSupp.current),
      expression: "vlaserSupp.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "vlaserSupp"
    },
    domProps: {
      "value": (_vm.vlaserSupp.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.vlaserSupp)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vlaserSupp, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.vlaserSupp.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid laser scanning speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Hatch distance:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hatch.current),
      expression: "hatch.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hatch"
    },
    domProps: {
      "value": (_vm.hatch.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.hatch)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hatch, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.hatch.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid hatch distance.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Recoater Crash Tolerance:")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          0.4 mm is the tolerance of a stiff recoater blade. Flexible recoater blade materials will allow for more\n                          z-direction displacement. Please indicate the tolerance of the recoater material employed for this build.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CrashTolerance.current),
      expression: "CrashTolerance.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "crashtolerancefield"
    },
    domProps: {
      "value": (_vm.CrashTolerance.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.CrashTolerance)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.CrashTolerance, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.CrashTolerance.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid recoater crash tolerance.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the critical angle for generating support structures (in degrees):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].critical_angle.current),
      expression: "files[0].critical_angle.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "critical_anglefield"
    },
    domProps: {
      "value": (_vm.files[0].critical_angle.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[0].critical_angle)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].critical_angle, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[0].critical_angle.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid angle.")]) : _vm._e(), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter material dependent scaling defined in your machine:\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("X-axis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scalingX_material.current),
      expression: "scalingX_material.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalingX_material"
    },
    domProps: {
      "value": (_vm.scalingX_material.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositiveFromZero(_vm.scalingX_material)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scalingX_material, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.scalingX_material.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid value.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Y-axis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scalingY_material.current),
      expression: "scalingY_material.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalingY_material"
    },
    domProps: {
      "value": (_vm.scalingY_material.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositiveFromZero(_vm.scalingY_material)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scalingY_material, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.scalingY_material.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid value.")]) : _vm._e(), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Please enter parameters for distortion compensation:")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].isCompensate),
      expression: "files[0].isCompensate"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isCompensate"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[0].isCompensate) ? _vm._i(_vm.files[0].isCompensate, null) > -1 : (_vm.files[0].isCompensate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[0].isCompensate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[0], "isCompensate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[0], "isCompensate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[0], "isCompensate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isCompensate"
    }
  }, [_vm._v("Create an additional job result that includes design modifications that compensate for thermal distortion (remeshing is required)")])]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Scaling Factor")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.compensationScale.current),
      expression: "compensationScale.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "compensationScale"
    },
    domProps: {
      "value": (_vm.compensationScale.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.compensationScale)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.compensationScale, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.compensationScale.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scale.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Mesh envelope size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tetraEps.current),
      expression: "tetraEps.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraEpsField"
    },
    domProps: {
      "value": (_vm.tetraEps.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.tetraEps)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tetraEps, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.tetraEps.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Tetra mesh size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tetraMeshSize.current),
      expression: "tetraMeshSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraMeshSizeField"
    },
    domProps: {
      "value": (_vm.tetraMeshSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.tetraMeshSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tetraMeshSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.tetraMeshSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e()])]), _vm._v(" "), _c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Support Structure\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isWithoutSupport),
      expression: "isWithoutSupport"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isWithoutSupport"
    },
    domProps: {
      "checked": Array.isArray(_vm.isWithoutSupport) ? _vm._i(_vm.isWithoutSupport, null) > -1 : (_vm.isWithoutSupport)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isWithoutSupport,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isWithoutSupport = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isWithoutSupport = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isWithoutSupport = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isWithoutSupport"
    }
  }, [_vm._v("Lay parts directly on build platform without any support")])]), _vm._v(" "), (!_vm.isWithoutSupport) ? _c('div', {
    staticClass: "center-align block-wrp block-wrp-100"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('input', {
    attrs: {
      "id": "uploadsupports",
      "accept": ".stl",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadSupports
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.selectSupportsFile
    }
  }, [_vm._v("Upload supports STL")]), _vm._v(" "), (Object.keys(_vm.fileSupports) > 0) ? _c('div', {
    staticClass: "block-buttons"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Supports units:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "visible": _vm.unitsuppvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.unitsuppvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.unitsuppvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.units_supp[_vm.files[0].unit_supp].name) + "\n                                    "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.units_supp), function(unit, index) {
    return _c('li', {
      key: unit.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.unitSuppChoice(index)
        }
      }
    }, [_vm._v(_vm._s(unit.name))])])
  }), 0)])])])], 1) : _vm._e(), _vm._v(" "), _vm._l((Object.keys(_vm.fileSupports)), function(fileSupport) {
    return _c('div', {
      key: fileSupport,
      staticClass: "block-support"
    }, [_c('div', {
      staticClass: "bold upload-supports"
    }, [_vm._v(_vm._s(_vm.fileSupports[fileSupport].name))]), _vm._v(" "), _c('button', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.removeSupportsFile(fileSupport)
        }
      }
    }, [_vm._v("Remove")])])
  }), _vm._v(" "), (_vm.uploadSupportsMessage) ? _c('div', [_vm._v(_vm._s(_vm.uploadSupportsMessage))]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (!(Object.keys(_vm.fileSupports).length > 0 || _vm.isWithoutSupport)) ? [_c('div', {
    staticClass: "center-align block-wrp with-image"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "block-input"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].suppSpacing_xy.current),
      expression: "files[0].suppSpacing_xy.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "suppSpacing_xyfield"
    },
    domProps: {
      "value": (_vm.files[0].suppSpacing_xy.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].suppSpacing_xy)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].suppSpacing_xy, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].suppSpacing_xy.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                              Please enter the size of the desired support at boundary.\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].supp_size_boundary.current),
      expression: "files[0].supp_size_boundary.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "supp_size_boundaryfield"
    },
    domProps: {
      "value": (_vm.files[0].supp_size_boundary.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].supp_size_boundary)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].supp_size_boundary, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].supp_size_boundary.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp__flex"
  }, [_c('div', {
    staticClass: "block-input block-input__half"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                              Support structure hatch distance\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].suppHatchSize.current),
      expression: "files[0].suppHatchSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "suppHatchSizefield"
    },
    domProps: {
      "value": (_vm.files[0].suppHatchSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].suppHatchSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].suppHatchSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].suppHatchSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "block-input block-input__half"
  }, [_c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStrengthSupp),
      expression: "isStrengthSupp"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isStrengthSupp"
    },
    domProps: {
      "checked": Array.isArray(_vm.isStrengthSupp) ? _vm._i(_vm.isStrengthSupp, null) > -1 : (_vm.isStrengthSupp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isStrengthSupp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isStrengthSupp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isStrengthSupp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isStrengthSupp = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "bold block-description",
    attrs: {
      "for": "isStrengthSupp"
    }
  }, [_vm._v("Use strengthened supports where distortion is highest?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp with-image"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-descripton"
  }, [_vm._v("\n                          Critical angle evaluated on:\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "support-checkboxes"
  }, [_c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEvalFacet),
      expression: "isEvalFacet"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isEvalFacet"
    },
    domProps: {
      "checked": Array.isArray(_vm.isEvalFacet) ? _vm._i(_vm.isEvalFacet, null) > -1 : (_vm.isEvalFacet)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isEvalFacet,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isEvalFacet = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isEvalFacet = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isEvalFacet = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isEvalFacet"
    }
  }, [_vm._v("STL faces")])]), _vm._v(" "), _c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEvalVertex),
      expression: "isEvalVertex"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isEvalVertex"
    },
    domProps: {
      "checked": Array.isArray(_vm.isEvalVertex) ? _vm._i(_vm.isEvalVertex, null) > -1 : (_vm.isEvalVertex)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isEvalVertex,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isEvalVertex = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isEvalVertex = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isEvalVertex = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isEvalVertex"
    }
  }, [_vm._v("STL vertices")])]), _vm._v(" "), _c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEvalEdge),
      expression: "isEvalEdge"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isEvalEdge"
    },
    domProps: {
      "checked": Array.isArray(_vm.isEvalEdge) ? _vm._i(_vm.isEvalEdge, null) > -1 : (_vm.isEvalEdge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isEvalEdge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isEvalEdge = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isEvalEdge = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isEvalEdge = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isEvalEdge"
    }
  }, [_vm._v("STL edges")])]), _vm._v(" "), _c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isFragmentation),
      expression: "isFragmentation"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isFragmentation"
    },
    domProps: {
      "checked": Array.isArray(_vm.isFragmentation) ? _vm._i(_vm.isFragmentation, null) > -1 : (_vm.isFragmentation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isFragmentation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isFragmentation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isFragmentation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isFragmentation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isFragmentation"
    }
  }, [_vm._v("Divide support blocks into fragments for easier removal")])]), _vm._v(" "), _c('div', {
    staticClass: "block-input"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fragmentationSize.current),
      expression: "fragmentationSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "fragmentationsizefield"
    },
    domProps: {
      "value": (_vm.fragmentationSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.fragmentationSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fragmentationSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.fragmentationSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid fragmentation size.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-33"
  }, [_c('div', {
    staticClass: "block-input block-support-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                                Change the following parameters to change the support geometry:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.wt.current),
      expression: "supportParams.wt.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.wt.min,
      "max": _vm.suppRanges.wt.max
    },
    domProps: {
      "value": (_vm.supportParams.wt.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('wt')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.wt, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.supportParams.wt.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('wt')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.pt.current),
      expression: "supportParams.pt.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.pt.min,
      "max": _vm.suppRanges.pt.max,
      "step": _vm.suppRanges.pt.step
    },
    domProps: {
      "value": (_vm.supportParams.pt.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('pt')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.pt, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.pt.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('pt')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.tt.current),
      expression: "supportParams.tt.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.tt.min,
      "max": _vm.suppRanges.tt.max,
      "step": _vm.suppRanges.tt.step
    },
    domProps: {
      "value": (_vm.supportParams.tt.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('tt')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.tt, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.tt.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('tt')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.ot.current),
      expression: "supportParams.ot.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.ot.min,
      "max": _vm.suppRanges.ot.max,
      "step": _vm.suppRanges.ot.step
    },
    domProps: {
      "value": (_vm.supportParams.ot.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('ot')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.ot, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.ot.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('ot')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.wb.current),
      expression: "supportParams.wb.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.wb.min,
      "max": _vm.suppRanges.wb.max
    },
    domProps: {
      "value": (_vm.supportParams.wb.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('wb')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.wb, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.supportParams.wb.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('wb')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.pb.current),
      expression: "supportParams.pb.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.pb.min,
      "max": _vm.suppRanges.pb.max,
      "step": _vm.suppRanges.pb.step
    },
    domProps: {
      "value": (_vm.supportParams.pb.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('pb')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.pb, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.pb.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('pb')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.tb.current),
      expression: "supportParams.tb.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.tb.min,
      "max": _vm.suppRanges.tb.max,
      "step": _vm.suppRanges.tb.step
    },
    domProps: {
      "value": (_vm.supportParams.tb.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('tb')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.tb, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.tb.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('tb')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.ob.current),
      expression: "supportParams.ob.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.ob.min,
      "max": _vm.suppRanges.ob.max,
      "step": _vm.suppRanges.ob.step
    },
    domProps: {
      "value": (_vm.supportParams.ob.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('ob')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.ob, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.ob.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('ob')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value-range"
  }, [_c('div', {
    staticClass: "field-name small"
  }, [_vm._v("Support Density")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-wrp"
  }, [_c('div', {
    staticClass: "tooltip"
  }, [_c('span', {
    staticClass: "tooltipvalue",
    style: ({
      left: parseInt(_vm.supportParams.fraction_avg.current * 100) + '%'
    })
  }, [_vm._v("\n                                    " + _vm._s(parseInt(_vm.supportParams.fraction_avg.current * 100)) + "\n                                ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.fraction_avg.current),
      expression: "supportParams.fraction_avg.current"
    }],
    attrs: {
      "type": "range",
      "min": _vm.suppRanges.fraction_avg.min,
      "max": _vm.suppRanges.fraction_avg.max,
      "step": _vm.suppRanges.fraction_avg.step
    },
    domProps: {
      "value": (_vm.supportParams.fraction_avg.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('fraction_avg')
      },
      "__r": function($event) {
        return _vm.$set(_vm.supportParams.fraction_avg, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), _c('div', {
    staticClass: "block-alert"
  }, [_vm._v("\n                                Increasing the support density will reduce the size of each support, making the aggregate of\n                                the supports more solid. Example: 100% density means that supports will create a solid \"wall\"\n                                of supports. Caution! Without teeth, removal of 100% solid supports would require machining.\n                            ")]), _vm._v(" "), (_vm.supportParams.fraction_avg.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('fraction_avg')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-33"
  }, [_c('draw-support', {
    attrs: {
      "params": _vm.supportParams
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-33"
  }, [_c('draw-support', {
    attrs: {
      "params": _vm.supportParams,
      "buildPlate": true
    }
  })], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row jobSpec"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].needRemesh),
      expression: "files[0].needRemesh"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "needRemesh"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[0].needRemesh) ? _vm._i(_vm.files[0].needRemesh, null) > -1 : (_vm.files[0].needRemesh)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.files[0].needRemesh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[0], "needRemesh", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[0], "needRemesh", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[0], "needRemesh", $$c)
        }
      }, function($event) {
        return _vm.toggleRemesh($event)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needRemesh"
    }
  }, [_vm._v("Match the resolution of the simulation to the resolution of the STL file (Remesh)")])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saveSpec),
      expression: "saveSpec"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "saveForNext"
    },
    domProps: {
      "checked": Array.isArray(_vm.saveSpec) ? _vm._i(_vm.saveSpec, null) > -1 : (_vm.saveSpec)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.saveSpec,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.saveSpec = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.saveSpec = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.saveSpec = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "saveForNext"
    }
  }, [_vm._v("Use this job's specifications for the next job")])]), _vm._v(" "), (Object.keys(this.fileSupports).length > 0 && !_vm.isWithoutSupport) ? _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPreviewSupports),
      expression: "isPreviewSupports"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isPreviewSupports"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPreviewSupports) ? _vm._i(_vm.isPreviewSupports, null) > -1 : (_vm.isPreviewSupports)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPreviewSupports,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPreviewSupports = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPreviewSupports = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPreviewSupports = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isPreviewSupports"
    }
  }, [_vm._v("Preview support in viewer")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(22), _vm._v(" "), (_vm.loading && _vm.statusMessage) ? _c('div', {
    staticClass: "col s12 center-align status-message"
  }, [_vm._v("\n                    " + _vm._s(_vm.statusMessage) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.loading && !_vm.nestedMode) ? _c('div', {
    staticClass: "progress"
  }, [(_vm.remeshingPart && _vm.remeshingProgress > 0) ? _c('div', {
    staticClass: "determinate",
    style: ({
      width: _vm.remeshingProgress * 100 + '%'
    })
  }) : _c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading && _vm.nestedMode) ? _c('div', {
    staticClass: "progress"
  }, [(_vm.remeshingPart.some(function (part) { return part === true; }) && _vm.remeshingProgress > 0) ? _c('div', {
    staticClass: "determinate",
    style: ({
      width: _vm.remeshingProgress * 100 + '%'
    })
  }) : _c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _vm._m(23), _vm._v(" "), (_vm.subscription || _vm.user.credits.length > 0) ? [(!(Object.keys(this.fileSupports).length > 0) || _vm.isWithoutSupport) ? [(!_vm.files[0].isCompensate) ? _c('div', {
    staticClass: "col s4"
  }, [_c('div', [_c('a', {
    staticClass: "btn a3d multiline",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(false, null)
      }
    }
  }, [_vm._v("Use AM Build Optimizer Intelligence")])])]) : _vm._e(), _vm._v(" "), (!_vm.files[0].isCompensate) ? _c('div', {
    staticClass: "col s4"
  }, [_c('div', [_c('a', {
    staticClass: "btn a3d inv multiline",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(true, false)
      }
    }
  }, [_vm._v("\n                                  Orient Manually & Generate Supports "), _c('b', [_vm._v("Without")]), _vm._v(" Simulation\n                              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col",
    class: {
      's4': !_vm.files[0].isCompensate, 's12': _vm.files[0].isCompensate
    }
  }, [_c('div', [_c('a', {
    staticClass: "btn a3d inv multiline",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(true, true)
      }
    }
  }, [_vm._v("\n                                  Orient Manually "), _c('b', [_vm._v("With")]), _vm._v(" Simulation\n                              ")])])])] : (Object.keys(this.fileSupports).length > 0 && !_vm.isWithoutSupport) ? [_c('div', {
    staticClass: "col offset-s3 s6"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "btn a3d inv",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(true, true)
      }
    }
  }, [_vm._v("\n                                  Open preview\n                              ")])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 offset-s4"
  }, [_c('div', {
    staticClass: "center-align",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [(!_vm.subscription) ? _c('h6', [_vm._v("This job costs 1 credit.")]) : _vm._e(), _vm._v(" "), (_vm.files[0].isCompensate) ? _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Distortion compensation is not possible without prediction of thermal distortion.")]) : _vm._e()])])])] : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 offset-s4"
  }, [_c('div', {
    staticClass: "center-align",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('button', {
    staticClass: "btn a3d",
    on: {
      "click": _vm.buymodal
    }
  }, [_vm._v("\n                                Buy Subscription\n                            ")]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("This job costs 1 credit.")])])])])], 2)] : [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "padding-top": "20px"
    }
  }, [_c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedJobFlow.isManually),
      expression: "nestedJobFlow.isManually"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isManuallyOrient"
    },
    domProps: {
      "checked": Array.isArray(_vm.nestedJobFlow.isManually) ? _vm._i(_vm.nestedJobFlow.isManually, null) > -1 : (_vm.nestedJobFlow.isManually)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.nestedJobFlow.isManually,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.nestedJobFlow, "isManually", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.nestedJobFlow, "isManually", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.nestedJobFlow, "isManually", $$c)
        }
      }, function($event) {
        return _vm.changeNestedJobsFlow()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isManuallyOrient"
    }
  }, [_vm._v("Orient my parts manually")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedJobFlow.isManualPlacement),
      expression: "nestedJobFlow.isManualPlacement"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isManualPlacement",
      "disabled": !_vm.nestedJobFlow.isManually
    },
    domProps: {
      "checked": Array.isArray(_vm.nestedJobFlow.isManualPlacement) ? _vm._i(_vm.nestedJobFlow.isManualPlacement, null) > -1 : (_vm.nestedJobFlow.isManualPlacement)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.nestedJobFlow.isManualPlacement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.nestedJobFlow, "isManualPlacement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.nestedJobFlow, "isManualPlacement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.nestedJobFlow, "isManualPlacement", $$c)
        }
      }, function($event) {
        return _vm.changeNestedJobsFlow()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isManualPlacement"
    }
  }, [_vm._v("Place my parts on the build tray manually")])])])]), _vm._v(" "), _c('div', {
    staticClass: "blocks-wrp"
  }, [_c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Build parameters\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input thickness of each powder layer (must be consistent with the layer thickness set in your printer):")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thickness.current),
      expression: "thickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thicknessfield"
    },
    domProps: {
      "value": (_vm.thickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.thickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.thickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.thickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser scanning speed:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.speed.current),
      expression: "speed.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "speedfield"
    },
    domProps: {
      "value": (_vm.speed.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.speed)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.speed, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.speed.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser beam diameter:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diameter.current),
      expression: "diameter.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "diameterfield"
    },
    domProps: {
      "value": (_vm.diameter.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.diameter)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.diameter, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.diameter.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid diameter.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser power:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.power.current),
      expression: "power.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "powerfield"
    },
    domProps: {
      "value": (_vm.power.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.power)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.power, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W")])]), _vm._v(" "), (_vm.power.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid power.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser scanning speed for support structures:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vlaserSupp.current),
      expression: "vlaserSupp.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "vlaserSupp"
    },
    domProps: {
      "value": (_vm.vlaserSupp.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.vlaserSupp)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vlaserSupp, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.vlaserSupp.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid laser scanning speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                          Number of lasers employed for this build\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          (only impacts build time calculation)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nlaser.current),
      expression: "nlaser.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "nlaserfield"
    },
    domProps: {
      "value": (_vm.nlaser.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.nlaser)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nlaser, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.nlaser.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid number of lasers.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Hatch distance:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hatch.current),
      expression: "hatch.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hatch"
    },
    domProps: {
      "value": (_vm.hatch.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.hatch)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hatch, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.hatch.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid hatch distance.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your suggested element size:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.element.current),
      expression: "element.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "elementfield"
    },
    domProps: {
      "value": (_vm.element.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.element)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.element, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.element.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e(), _vm._v(" "), _vm._m(24)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the temperature of the build platform.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tplate.current),
      expression: "tplate.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tplatefield"
    },
    domProps: {
      "value": (_vm.tplate.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.tplate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tplate, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.tplate.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), (!_vm.nestedJobFlow.isManualPlacement) ? _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Input the number of degrees each part should be rotated about the\n                            z-axis during each optimization iteration for maximizing the number\n                            of parts on the build plate:\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deltaR.current),
      expression: "deltaR.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "deltarfield"
    },
    domProps: {
      "value": (_vm.deltaR.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumExactRange(_vm.deltaR, 1, 360)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deltaR, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°")])]), _vm._v(" "), (_vm.deltaR.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid degree.")]) : _vm._e(), _vm._v(" "), _vm._m(25)])]) : _vm._e(), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Build plate margin from the border by X-axis\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginX.current),
      expression: "marginX.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "marginXfield"
    },
    domProps: {
      "value": (_vm.marginX.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumExactRange(_vm.marginX, 0, _vm.parentJobConfig.plateWidth / 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.marginX, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.marginX.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Invalid margin. Must be " + _vm._s(_vm.parentJobConfig.plateWidth / 2) + " - mm")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Build plate margin from the border by Y-axis\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginY.current),
      expression: "marginY.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "marginYfield"
    },
    domProps: {
      "value": (_vm.marginY.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumExactRange(_vm.marginY, 0, _vm.parentJobConfig.plateHeight / 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.marginY, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.marginY.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Invalid margin. Must be " + _vm._s(_vm.parentJobConfig.plateHeight / 2) + " - 0 mm")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "blocks-wrp"
  }, [_c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Part parameters\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "block-full-width"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partParamsAll),
      expression: "partParamsAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "useForAll"
    },
    domProps: {
      "checked": Array.isArray(_vm.partParamsAll) ? _vm._i(_vm.partParamsAll, null) > -1 : (_vm.partParamsAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.partParamsAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.partParamsAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.partParamsAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.partParamsAll = $$c
        }
      }, function($event) {
        return _vm.switchPartParamAll()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useForAll"
    }
  }, [_vm._v("Use the same parameters for all nested parts")])])]), _vm._v(" "), (!_vm.partParamsAll) ? _c('div', {
    staticClass: "block-dots top center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: fileObj.id,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the units you selected when creating your .stl file (usually mm or cm):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('dropdown', {
    attrs: {
      "visible": _vm.unitvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.unitvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.unitvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.units[_vm.files[_vm.fileIndex].unit - 1].name) + "\n                                    "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.units), function(unit, index) {
    return _c('li', {
      key: 'nested' + unit.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.unitChoice(index)
        }
      }
    }, [_vm._v(_vm._s(unit.name))])])
  }), 0)])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the scaling factor you want to apply when printing the file, relative to your .stl file (example: if you want to print at 150% the dimensions of your .stl file, you would enter 1.50):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].scale.current),
      expression: "files[fileIndex].scale.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalefield"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].scale.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[_vm.fileIndex].scale)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex].scale, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[_vm.fileIndex].scale.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scale.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the distance between the part and the build platform.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].hsub.current),
      expression: "files[fileIndex].hsub.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hsubfield"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].hsub.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[_vm.fileIndex].hsub)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex].hsub, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[_vm.fileIndex].hsub.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the critical angle for generating support structures (in degrees):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].critical_angle.current),
      expression: "files[fileIndex].critical_angle.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "critical_anglefield"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].critical_angle.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[_vm.fileIndex].critical_angle)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex].critical_angle, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[_vm.fileIndex].critical_angle.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid angle.")]) : _vm._e(), _vm._v(" "), _vm._m(27)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-dots bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].needRemesh),
      expression: "files[fileIndex].needRemesh"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "needRemesh"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].needRemesh) ? _vm._i(_vm.files[_vm.fileIndex].needRemesh, null) > -1 : (_vm.files[_vm.fileIndex].needRemesh)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.files[_vm.fileIndex].needRemesh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "needRemesh", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "needRemesh", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "needRemesh", $$c)
        }
      }, function($event) {
        return _vm.toggleNestedRemesh($event, _vm.fileIndex)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needRemesh"
    }
  }, [_vm._v("Match the resolution of the simulation to the resolution of the STL file (Remesh)")])]), _vm._v(" "), (!_vm.partParamsAll) ? _c('div', {
    staticClass: "block-dots bottom center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: 'nested' + fileObj.pathKey,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 offset-s3 job-name"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Name of Nested job:")]), _vm._v(" "), _c('div', {
    staticClass: "input-field inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedJobName.current),
      expression: "nestedJobName.current"
    }],
    attrs: {
      "id": "nestedJobName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.nestedJobName.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.nestedJobName, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nestedJobName, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.nestedJobName.invalid) ? _c('div', {
    staticClass: "error center-align"
  }, [_vm._v("\n                        Enter valid job name\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col s6 offset-s3 center-align"
  }, [_vm._v("Enter the name you would like to use to refer to this job in your dashboard")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.submitting) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goNext()
      }
    }
  }, [_vm._v("Next")])])])], _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "padding-top": "3px"
    }
  }, [_c('modal', {
    ref: "otherprintermodal",
    attrs: {
      "name": "otherprintermodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "70%"
    },
    on: {
      "before-close": function($event) {
        return _vm.beforeClosePrinter()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Printer name:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.name.current),
      expression: "printerCustom.name.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "printerName"
    },
    domProps: {
      "value": (_vm.printerCustom.name.current)
    },
    on: {
      "change": function($event) {
        _vm.verifyPrinterName(_vm.printerCustom.name) && _vm.verifyString(_vm.printerCustom.name, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.name, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.printerCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input unique name.")]) : _vm._e(), _vm._v(" "), (_vm.printerCustom.name.invalid && !_vm.printerCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build chamber height:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateZ.current),
      expression: "printerCustom.plateZ.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "chamberHeight"
    },
    domProps: {
      "value": (_vm.printerCustom.plateZ.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateZ)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateZ, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateZ.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid height.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build plate width:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateX.current),
      expression: "printerCustom.plateX.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "plateWidth"
    },
    domProps: {
      "value": (_vm.printerCustom.plateX.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateX)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateX, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateY.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid width.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build plate length:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateY.current),
      expression: "printerCustom.plateY.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "plateLength"
    },
    domProps: {
      "value": (_vm.printerCustom.plateY.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateY)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateY, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateX.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid length.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build plate thickness:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateThickness.current),
      expression: "printerCustom.plateThickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "plateThickness"
    },
    domProps: {
      "value": (_vm.printerCustom.plateThickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateThickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateThickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateThickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid length.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Recoater blade direction:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.DirectionRecoater.current),
      expression: "printerCustom.DirectionRecoater.current"
    }],
    attrs: {
      "name": "bladeDirection",
      "type": "radio",
      "id": "width",
      "value": "width"
    },
    domProps: {
      "checked": _vm._q(_vm.printerCustom.DirectionRecoater.current, "width")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.printerCustom.DirectionRecoater, "current", "width")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "width"
    }
  }, [_vm._v("Blade travels across the plate width")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.DirectionRecoater.current),
      expression: "printerCustom.DirectionRecoater.current"
    }],
    attrs: {
      "name": "bladeDirection",
      "type": "radio",
      "id": "length",
      "value": "length"
    },
    domProps: {
      "checked": _vm._q(_vm.printerCustom.DirectionRecoater.current, "length")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.printerCustom.DirectionRecoater, "current", "length")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "length"
    }
  }, [_vm._v("Blade travels across the plate length")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default Infill laser beam scan speed:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.speed.current),
      expression: "printerCustom.speed.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scanningSpeed"
    },
    domProps: {
      "value": (_vm.printerCustom.speed.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.speed)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.speed, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.printerCustom.speed.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scan speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build Time Calibration Factor:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.calibrationFactor.current),
      expression: "printerCustom.calibrationFactor.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "calibrationFactor"
    },
    domProps: {
      "value": (_vm.printerCustom.calibrationFactor.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumBetween(_vm.printerCustom.calibrationFactor, 0, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.calibrationFactor, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.printerCustom.calibrationFactor.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Build Time Calibration Factor should be between 0 and 2.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default Infill laser beam diameter:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.diameter.current),
      expression: "printerCustom.diameter.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "beamDiameter"
    },
    domProps: {
      "value": (_vm.printerCustom.diameter.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.diameter)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.diameter, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.printerCustom.diameter.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid diameter.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default Infill laser beam power:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.power.current),
      expression: "printerCustom.power.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "laserPower"
    },
    domProps: {
      "value": (_vm.printerCustom.power.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.power)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.power, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W")])]), _vm._v(" "), (_vm.printerCustom.power.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid power.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default thickness of each powder layer (must be consistent with the layer thickness set in your printer):")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.thickness.current),
      expression: "printerCustom.thickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "layerThickness"
    },
    domProps: {
      "value": (_vm.printerCustom.thickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.thickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.thickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.printerCustom.thickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-button"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addPrinter()
      }
    }
  }, [_vm._v("Save printer")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_vm._v("\n                        AM Build Optimizer should work on any DMLS printer - however, only the printers listed have been validated.\n                        Please enter your printer’s make and model so we can add it to our validation work and eventually add it to the dropdown list.\n                        Please click the button below to send us an email with information to help us optimize for your printer.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_c('a', {
    staticClass: "a3d btn small inv",
    staticStyle: {
      "margin-top": "20px",
      "width": "50%"
    },
    attrs: {
      "href": "mailto:support@atlas3d.xyz?subject=Job%20with%20Unsupported%20Material?body=Please%20insert%20the%20following%20information%2C%20and%20any%20other%20relevant%20information:%20Printer%20Make%2C%20Printer%20model."
    }
  }, [_vm._v("Send Email\n                        ")])])])]), _vm._v(" "), _c('modal', {
    ref: "othermaterialmodal",
    attrs: {
      "name": "othermaterialmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "70%"
    },
    on: {
      "before-close": function($event) {
        return _vm.beforeCloseMaterial()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Material name:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.name.current),
      expression: "materialCustom.name.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "materialName"
    },
    domProps: {
      "value": (_vm.materialCustom.name.current)
    },
    on: {
      "change": function($event) {
        _vm.verifyMaterialName(_vm.materialCustom.name) && _vm.verifyString(_vm.materialCustom.name, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.name, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.materialCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input unique name.")]) : _vm._e(), _vm._v(" "), (_vm.materialCustom.name.invalid && !_vm.materialCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Poisson's Ratio:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.nu.current),
      expression: "materialCustom.nu.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "poissonsRatio"
    },
    domProps: {
      "value": (_vm.materialCustom.nu.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.nu)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.nu, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.materialCustom.nu.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Poisson's Ratio.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Young's modulus:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.E.current),
      expression: "materialCustom.E.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "elasticity"
    },
    domProps: {
      "value": (_vm.materialCustom.E.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.E)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.E, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("GPa")])]), _vm._v(" "), (_vm.materialCustom.E.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Young's modulus.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Young's modulus at high temperatures:")]), _vm._v(" "), _vm._l((_vm.materialCustom.E_heat), function(value, valueIndex) {
    return [_c('div', {
      key: valueIndex,
      staticClass: "block-value"
    }, [(_vm.materialCustom.E_heat.length > 1) ? _c('div', {
      staticClass: "icon-remove"
    }, [_c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeMaterialHeatDependentValue(_vm.materialCustom.E_heat, valueIndex)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")])]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.E_heat[valueIndex].temperature.current),
        expression: "materialCustom.E_heat[valueIndex].temperature.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.E_heat[valueIndex].temperature.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.E_heat[valueIndex].temperature)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.E_heat[valueIndex].temperature, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit first"
    }, [_vm._v("°C")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.E_heat[valueIndex].value.current),
        expression: "materialCustom.E_heat[valueIndex].value.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.E_heat[valueIndex].value.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.E_heat[valueIndex].value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.E_heat[valueIndex].value, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit"
    }, [_vm._v("GPa")])]), _vm._v(" "), (_vm.materialCustom.E_heat[valueIndex].temperature.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid temperature.")]) : _vm._e(), _vm._v(" "), (_vm.materialCustom.E_heat[valueIndex].value.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid Young's modulus.")]) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "block-buttons"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addMaterialHeatDependentValue(_vm.materialCustom.E_heat)
      }
    }
  }, [_vm._v("Add")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Density:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.rho.current),
      expression: "materialCustom.rho.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "density"
    },
    domProps: {
      "value": (_vm.materialCustom.rho.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.rho)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.rho, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("kg/m"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), (_vm.materialCustom.rho.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Density.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Specific Heat:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.Cp.current),
      expression: "materialCustom.Cp.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "specificHeat"
    },
    domProps: {
      "value": (_vm.materialCustom.Cp.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.Cp)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.Cp, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("J/(kgK)")])]), _vm._v(" "), (_vm.materialCustom.Cp.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Specific Heat.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Thermal Conductivity:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.k.current),
      expression: "materialCustom.k.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thermalConductivity"
    },
    domProps: {
      "value": (_vm.materialCustom.k.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.k)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.k, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W/(mK)")])]), _vm._v(" "), (_vm.materialCustom.k.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Thermal Conductivity.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Solidus Temperature:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.Tsolid.current),
      expression: "materialCustom.Tsolid.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "solidusTemp"
    },
    domProps: {
      "value": (_vm.materialCustom.Tsolid.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.Tsolid)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.Tsolid, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.materialCustom.Tsolid.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Liquidus temperature:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.Tliquid.current),
      expression: "materialCustom.Tliquid.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "liquidusTemp"
    },
    domProps: {
      "value": (_vm.materialCustom.Tliquid.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.Tliquid)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.Tliquid, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.materialCustom.Tliquid.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Yield Stress:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.sigma_y.current),
      expression: "materialCustom.sigma_y.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "yieldStress"
    },
    domProps: {
      "value": (_vm.materialCustom.sigma_y.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.sigma_y)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.sigma_y, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("MPa")])]), _vm._v(" "), (_vm.materialCustom.sigma_y.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Yield Stress.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Yield Stress at high temperatures:")]), _vm._v(" "), _vm._l((_vm.materialCustom.sigma_y_heat), function(value, valueIndex) {
    return [_c('div', {
      key: valueIndex,
      staticClass: "block-value"
    }, [(_vm.materialCustom.sigma_y_heat.length > 1) ? _c('div', {
      staticClass: "icon-remove"
    }, [_c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeMaterialHeatDependentValue(_vm.materialCustom.sigma_y_heat, valueIndex)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")])]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.sigma_y_heat[valueIndex].temperature.current),
        expression: "materialCustom.sigma_y_heat[valueIndex].temperature.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.sigma_y_heat[valueIndex].temperature.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.sigma_y_heat[valueIndex].temperature)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.sigma_y_heat[valueIndex].temperature, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit first"
    }, [_vm._v("°C")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.sigma_y_heat[valueIndex].value.current),
        expression: "materialCustom.sigma_y_heat[valueIndex].value.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.sigma_y_heat[valueIndex].value.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.sigma_y_heat[valueIndex].value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.sigma_y_heat[valueIndex].value, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit"
    }, [_vm._v("MPa")])]), _vm._v(" "), (_vm.materialCustom.sigma_y_heat[valueIndex].temperature.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid temperature.")]) : _vm._e(), _vm._v(" "), (_vm.materialCustom.sigma_y_heat[valueIndex].value.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid Young's modulus.")]) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "block-buttons"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addMaterialHeatDependentValue(_vm.materialCustom.sigma_y_heat)
      }
    }
  }, [_vm._v("Add")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Melting Latent Heat:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.hsl.current),
      expression: "materialCustom.hsl.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "meltingHeat"
    },
    domProps: {
      "value": (_vm.materialCustom.hsl.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.hsl)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.hsl, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("kJ/kg")])]), _vm._v(" "), (_vm.materialCustom.hsl.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Melting Latent Heat.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Thermal Expansion Coefficient:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.alpha.current),
      expression: "materialCustom.alpha.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thermalExpansion"
    },
    domProps: {
      "value": (_vm.materialCustom.alpha.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.alpha)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.alpha, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("10"), _c('sup', [_vm._v("-6")]), _vm._v("/°C")])]), _vm._v(" "), (_vm.materialCustom.alpha.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Thermal Expansion Coefficient.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-button"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addMaterial(false)
      }
    }
  }, [_vm._v("Save material")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_vm._v("\n                        AM Build Optimizer has not been validated with your material.\n                        We will attempt to gather the required material properties and eventually add it to the dropdown list.\n                        Please click the button below to send us an email with information to help optimize for your material.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_c('a', {
    staticClass: "a3d btn small inv",
    staticStyle: {
      "margin-top": "20px",
      "width": "50%"
    },
    attrs: {
      "href": "mailto:support@atlas3d.xyz?subject=Job%20with%20Unsupported%20Material?body=Please%20insert%20the%20following%20information%2C%20and%20any%20other%20relevant%20information:%20Material%20name%2C%20material%20description%2C%20and%20source."
    }
  }, [_vm._v("Send Email\n                        ")])])])]), _vm._v(" "), _c('modal', {
    ref: "cautionmodal",
    attrs: {
      "name": "cautionmodal",
      "pivotY": 0.4,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "caution-modal"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('b', [_vm._v("Caution:")]), _vm._v(" Changing these parameters may prevent your\n                        part from printing successfully. If you are an advanced user, please\n                        proceed and make your desired changes.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_vm._v("\n                        Click \"OK\" to proceed, or \"Cancel\" to return to the previous screen.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.acceptModal(true)
      }
    }
  }, [_vm._v("OK")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.acceptModal(false)
      }
    }
  }, [_vm._v("Cancel")])])])])])], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s6 offset-s3 center-align"
  }, [_c('h5', [_vm._v("\n            There was a problem processing your file.  We will return to you to the dashboard in a few seconds.  If this consumed one of your credits, please contact us with details and we will correct this.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (If the distance is 0, the part will be built directly from the build platform.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (We suggest 2 mm. A smaller element size will result in a more accurate optimization, but a longer processing time.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                Surfaces with angles relative to the build plate smaller than this angle will be supported\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                Material dependent scaling is a global addition or subtraction of material in the indicated plane.\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                            higher value gives more compensation\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/support-wl.png"),
      "alt": "Support width and length"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                              Individual support width and length (WL"), _c('sub', [_vm._v("0")]), _vm._v(")\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                  (The default is 1.0 mm)\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                  (The default is 0.6 mm)\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                  (The default is 3.5 mm)\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/support-fs.png"),
      "alt": "Critical angle"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Fragmentation size (S"), _c('sub', [_vm._v("0")]), _vm._v("):")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("W"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("P"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("T"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("O"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("W"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("P"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("T"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("O"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Prepare file for print run:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s10 offset-s1",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                        You can choose to orient your part manually. AM Build Optimizer™ will automatically add support structures where you need them.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (We suggest 2 mm. A smaller element size will result in a more accurate optimization, but a longer processing time.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (30 degrees is recommended. A lower number will potentially result\n                                in a higher density, but the optimization will take longer to\n                                complete. Enter ‘360’ to fix the z rotation.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (If the distance is 0, the part will be built directly from the build platform.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (Surfaces with angles to the horizontal smaller than the critical angle will be supported.)\n                            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7055ef20", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7055ef20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Create.vue
// module id = 487
// module chunks = 1